export default __webpack_public_path__ + "static/media/apple-watch-ultra.5e185acb.jpg";